import React from "react";
import { Trash2, Plus } from "lucide-react";

// Reusable "add / edit / remove" list editor used across admin forms
// (Site Editor sections, tour detail-page sections, etc.)
const RepeatableList = ({ items, onChange, renderItem, newItem, label = "item" }) => {
  const add = () => onChange([...(items || []), newItem()]);
  const remove = (idx) => onChange(items.filter((_, i) => i !== idx));
  const update = (idx, next) => onChange(items.map((it, i) => (i === idx ? next : it)));
  return (
    <div className="space-y-3">
      {(items || []).map((it, idx) => (
        <div key={idx} className="rounded-xl border border-[var(--ri-border)] bg-[var(--ri-cream)] p-4 relative">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[11px] uppercase tracking-widest text-[var(--ri-muted)]">
              {label} #{idx + 1}
            </span>
            <button
              type="button"
              onClick={() => remove(idx)}
              className="text-red-600 hover:bg-red-50 p-1 rounded"
              aria-label="Remove"
            >
              <Trash2 size={14} />
            </button>
          </div>
          {renderItem(it, (next) => update(idx, next))}
        </div>
      ))}
      <button type="button" onClick={add} className="btn-outline text-[13px] inline-flex items-center gap-2">
        <Plus size={14} /> Add {label}
      </button>
    </div>
  );
};

export default RepeatableList;
